import { classes } from '@theme/constants';
import { HTMLCustomElement } from '@theme/html-custom-element';

class ProductGuideRequirements extends HTMLCustomElement {
  connectedCallback() {
    if (super.connectedCallback) super.connectedCallback();

    if (this.refs.buttons && this.refs.button) {
      this.refs.buttons.append(...this.refs.button.all);
    }

    if (this.refs.products && this.refs.product) {
      this.refs.products.append(...this.refs.product.all);
    }

    if (this.refs.button) {
      this.on('click', this.refs.button.all, this.handleButtonClickEvent.bind(this));

      /**
       * Show the first item and handle resizing.
       */
      this.handleButtonClickEvent({ currentTarget: this.refs.button });

      this.resizeObserver = new ResizeObserver(() => {
        const button = this.refs.button.all.find((button) => button.classList.contains(classes.active));

        if (button) {
          this.handleButtonClickEvent({ currentTarget: button });
        }
      });

      this.resizeObserver.observe(this);
    }

    this.on('click', this.refs.header, () => {
      this.classList.toggle(classes.open);
    });
  }

  /**
   * @param {MouseEvent} event
   */
  handleButtonClickEvent(event) {
    const buttonProduct = this.refs.product.all.find(
      (product) => product.dataset.blockId === event.currentTarget.dataset.blockId,
    );

    if (buttonProduct) {
      buttonProduct.classList.add(classes.active);

      /**
       * Set the parent height.
       */
      if (!(buttonProduct.offsetHeight === 0)) {
        this.refs.products.style.height = `calc(${buttonProduct.offsetHeight}px + ${getComputedStyle(buttonProduct).marginBlockEnd})`;
      }

      for (const product of this.refs.product.all) {
        if (!(product === buttonProduct)) {
          product.classList.remove(classes.active);
        }
      }
    }

    for (const button of this.refs.button.all) {
      button.classList.toggle(classes.active, button.dataset.blockId === event.currentTarget.dataset.blockId);
    }
  }

  disconnectedCallback() {
    if (super.disconnectedCallback) super.disconnectedCallback();

    this.resizeObserver.disconnect();
  }
}

if (!customElements.get('product-guide-requirements'))
  customElements.define('product-guide-requirements', ProductGuideRequirements);
